import React, { useEffect } from 'react'
import BannerMainImageSection from '../../bannerMainImageSection'
import BannerBrandImageSection from '../../bannerBrandImageSection'
import { useSelector, useDispatch } from 'react-redux'
import withLocation from '../../withLocation'
import { connect } from 'react-redux'
import Layout from '../../../layout'
import ContentSection from './contentSection'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  checkConsultant,
} from '../../../helpers'
import { useHistory } from 'react-router-dom'
import useNextSteps from 'application/helpers/usenextSteps'
import NextStepContent from './nextStepContent'
import { fetchIndividualEstimate } from 'application/actions/individualEstimateActions'
import { fetchIndividualEstimate as fetchIndividualEstimateConsultant } from 'application/actions/consultantIndividualEstimateActions'
import { httpVerbConstants } from 'application/constants/actionTypes'
import * as E from './homeElements'
import EstimateToBeReviewedStage from './stages/EstimateToBeReviewedStage'
import ProposalToBeReviewedStage from './stages/ProposalToBeReviewedStage'
import OpportunityLostStage from './stages/OpportunityLostStage'
import EstimateAcceptedStage from './stages/EstimateAcceptedStage'
import ProposalAcceptedWithoutNextStepsStage from './stages/ProposalAcceptedWithoutNextStepsStage'
import { IHomeIndexProps } from './homeInterfaces/IHomeIndexProps'
import { INextStepProps } from './homeInterfaces/INextStepProps'
import { fetchFinAppStatus } from 'application/actions/finAppStatusActions'
import { fetchFinAppStatusConsultant } from 'application/actions/consultantFinAppStatusActions'
import { FinAppStatusValue } from 'application/utils/type'
import SettlementStage from './stages/SettlementStage'
import globals from 'application/constants/globals'
import { ISettlementRecipient } from '../ISettlementInputProps'

interface IStateApplicationRole {
  applicationRoles: any
}
interface IStateOpportunity {
  opportunity: any
}
interface IStateProposalEstimate {
  individualEstimate: { estimate: any }
}
interface IStateEmailProposal {
  email: { isEmailProposalView: boolean }
}
interface IStateUser {
  user: { hasSpartaVehicle: boolean; isAtSettlement: boolean }
}

const Home = ({
  isAuthenticated,
  opportunityId,
  consultantFirstName,
  userFirstName,
  proposalEstimateId,
  selectedEstimateId,
  applicationRole,
  accessToken,
  nextSteps,
  theme,
  isGov,
}: IHomeIndexProps) => {
  const history = useHistory()
  const dispatch = useDispatch()
  let headers = { accessToken: accessToken }
  const isConsultant = applicationRole.isConsultant
  const getNextSteps = useNextSteps()
  const { proposalCompleted, nextStepMethod } = getNextSteps
  const userEvents = () => {
    if (
      proposalEstimateId &&
      proposalEstimateId !== '00000000-0000-0000-0000-000000000000' &&
      proposalEstimateId !== selectedEstimateId
    ) {
      // Make sure this call does not update the analytics data
      dispatch(
        fetchIndividualEstimate(opportunityId, proposalEstimateId, true, false)
      )
    }

    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:home' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:home' },
        },
      })
    }
  }

  const consultantEvents = () => {
    if (
      proposalEstimateId &&
      proposalEstimateId !== '00000000-0000-0000-0000-000000000000' &&
      proposalEstimateId !== selectedEstimateId
    ) {
      dispatch(
        fetchIndividualEstimateConsultant(
          opportunityId,
          proposalEstimateId,
          headers,
          httpVerbConstants.HTTP_GET
        )
      )
    }

    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'maxxia:mylease:consultant:home' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'maxxia:mylease:consultant:home' },
        },
      })
    }
  }
  useEffect(() => {
    proposalCompleted && nextStepMethod()
  }, [proposalCompleted])

  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      checkConsultant() ? consultantEvents() : userEvents()
    }
  }, [isAuthenticated, opportunityId])

  let firstName = userFirstName

  let applicationRoles = useSelector(
    (state: IStateApplicationRole) => state.applicationRoles
  )
  let opportunity = useSelector((state: IStateOpportunity) => state.opportunity)

  let financeApplicationNumber =
    opportunity && opportunity.financeapplicationnumber

  useEffect(() => {
    if (financeApplicationNumber)
      checkConsultant()
        ? dispatch(
            fetchFinAppStatusConsultant(
              financeApplicationNumber,
              headers,
              httpVerbConstants.HTTP_GET
            )
          )
        : dispatch(fetchFinAppStatus(opportunityId, financeApplicationNumber))
  }, [financeApplicationNumber])

  const reviewProposalLink = `${isConsultant ? '/consultant' : ''}/proposal/${proposalEstimateId}/review`
  let viewAcceptedProposal = `${isConsultant ? '/consultant' : ''}/proposal/${proposalEstimateId}/review/pdfview`
  let estimateLink = `${isConsultant ? '/consultant' : ''}/estimates`
  let settlementLink = `${isConsultant ? '/consultant' : ''}/settlements`
  let d = document.getElementById('notification')
  if (d) d.style.display = 'none'

  let proposalEstimate = useSelector((state: IStateProposalEstimate) =>
    state.individualEstimate && state.individualEstimate.estimate
      ? state.individualEstimate.estimate
      : null
  )

  let customerHasAcceptedProposal =
    applicationRoles &&
    applicationRoles.hasProposal &&
    applicationRoles.hasSubmittedEstimate &&
    applicationRoles.hasProposalAccepted &&
    opportunity &&
    opportunity.state &&
    opportunity.state !== 'Lost'

  let isProposalCreated =
    applicationRoles &&
    applicationRoles.hasProposal &&
    applicationRoles.hasSubmittedEstimate &&
    opportunity &&
    opportunity.state &&
    opportunity.state !== 'Lost'

  let digitalSettlement = useSelector(
    (state: IStateOpportunity) =>
      state.opportunity.settlement &&
      state.opportunity.settlement.recipients &&
      state.opportunity.settlement.recipients.length > 0
  )

  let isAtSettlement = useSelector(
    (state: IStateOpportunity) =>
      state.opportunity.settlement &&
      state.opportunity.settlement.recipients &&
      state.opportunity.settlement.recipients.filter(
        (r: ISettlementRecipient) => !r.hasSigned
      ).length > 0 &&
      customerHasAcceptedProposal
  ) //Currently in settlement process, has agreement not completed

  var isEmailProposalView = useSelector(
    (state: IStateEmailProposal) => state.email.isEmailProposalView
  )
  if (proposalEstimateId && isEmailProposalView && opportunityId) {
    history.push(viewAcceptedProposal)
  }
  const isSparta = useSelector(
    (state: IStateUser) => state.user && state.user.hasSpartaVehicle
  )

  const isRe_lease = false
  {
    /*uncomment this code when release is enabled: opportunity &&
    opportunity.channel &&
  opportunity.channel.toLowerCase() == 'release' */
  }

  let registrationNumber = ''
  let currentOutOfPocket = 0
  let leaseEndDate = ''
  if (isRe_lease) {
    registrationNumber = opportunity.registrationNumber
    currentOutOfPocket = opportunity.currentNLOutOfPocketCostPerPay
    leaseEndDate = opportunity.leaseEndDate
  }

  let finAppStatus = useSelector((state: any) => state.finAppStatus)

  const estimateToBeReviewedStageProps = {
    firstName: firstName,
    estimateLink: estimateLink,
    isRelease: isRe_lease,
    isSparta: isSparta,
    consultantFirstName: consultantFirstName,
    finAppUrl:
      finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
      finAppStatus.status == FinAppStatusValue.STARTED
        ? finAppStatus.url
        : '',
    theme: theme,
  }

  const opportunityLostStageProps = {
    firstName: firstName,
  }

  const estimateAcceptedStageProps = {
    firstName: firstName,
    consultantFirstName: consultantFirstName,
    isConsultant: isConsultant,
  }

  const proposalToBeReviewedStageProps = {
    firstName: firstName,
    consultantFirstName: consultantFirstName,
    vehicleDescription:
      proposalEstimate && proposalEstimate.vehicle
        ? `${proposalEstimate.vehicle.year} ${proposalEstimate.vehicle.make} ${proposalEstimate.vehicle.family}`
        : '',
    isSparta: isSparta,
    estimateLink: estimateLink,
    reviewProposalLink: reviewProposalLink,
  }

  const proposalAcceptedWithoutNextStepsStageProps = {
    firstName: firstName,
    settlementLink: settlementLink,
    proposalLink: viewAcceptedProposal,
  }

  const settlementStageProps = {
    firstName: firstName,
    vehicleDescription:
      proposalEstimate && proposalEstimate.vehicle
        ? `${proposalEstimate.vehicle.year} ${proposalEstimate.vehicle.make} ${proposalEstimate.vehicle.family}`
        : '',
    proposalLink: viewAcceptedProposal,
    settlementLink: settlementLink,
  }

  const contentSectionData = {
    consultantFirstName: consultantFirstName,
    applicationRole: applicationRoles.CUSTOMER,
    isrelease: isRe_lease,
    isProposalCreated: isProposalCreated,
    registrationNumber: registrationNumber,
    currentNLOutOfPocket: currentOutOfPocket,
    leaseEndDate: leaseEndDate,
    theme: theme,
    isGov: isGov,
  }

  return (
    <Layout>
      <E.HomeContainer id="page" theme={theme}>
        {opportunity && opportunity.state && opportunity.state === 'Lost' && (
          <>
            <OpportunityLostStage
              firstName={opportunityLostStageProps.firstName}
              theme={theme}
            />
          </>
        )}
        {applicationRoles &&
          !applicationRoles.hasProposal &&
          !applicationRoles.hasSubmittedEstimate &&
          opportunity &&
          opportunity.state &&
          opportunity.state !== 'Lost' && (
            <EstimateToBeReviewedStage {...estimateToBeReviewedStageProps} />
          )}
        {applicationRoles &&
          !applicationRoles.hasProposal &&
          applicationRoles.hasSubmittedEstimate &&
          !applicationRoles.hasProposalAccepted &&
          opportunity &&
          opportunity.state &&
          opportunity.state !== 'Lost' && (
            <>
              <EstimateAcceptedStage
                firstName={estimateAcceptedStageProps.firstName}
                consultantFirstName={
                  estimateAcceptedStageProps.consultantFirstName
                }
                isConsultant={estimateAcceptedStageProps.isConsultant}
                theme={theme}
                finAppStatus={finAppStatus}
              />
            </>
          )}

        {customerHasAcceptedProposal &&
          opportunity &&
          opportunity.state === 'Won' &&
          !isAtSettlement && (
            <>
              <ProposalAcceptedWithoutNextStepsStage
                firstName={proposalAcceptedWithoutNextStepsStageProps.firstName}
                settlementLink={
                  proposalAcceptedWithoutNextStepsStageProps.settlementLink
                }
                proposalLink={
                  proposalAcceptedWithoutNextStepsStageProps.proposalLink
                }
                digitalSettlement={digitalSettlement}
                theme={theme}
              />
            </>
          )}

        {customerHasAcceptedProposal &&
          opportunity &&
          opportunity.state !== 'Won' &&
          !isAtSettlement && (
            <>
              <NextStepContent
                nextSteps={nextSteps}
                proposalEstimate={proposalEstimate}
                firstName={firstName}
                consultantFirstName={consultantFirstName}
                viewAcceptedProposal={viewAcceptedProposal}
                theme={theme}
              />
            </>
          )}

        {applicationRoles &&
          applicationRoles.hasProposal &&
          applicationRoles.hasSubmittedEstimate &&
          !applicationRoles.hasProposalAccepted &&
          opportunity &&
          opportunity.state &&
          opportunity.state !== 'Lost' && (
            <>
              <ProposalToBeReviewedStage
                firstName={proposalToBeReviewedStageProps.firstName}
                consultantFirstName={
                  proposalToBeReviewedStageProps.consultantFirstName
                }
                vehicleDescription={
                  proposalToBeReviewedStageProps.vehicleDescription
                }
                isSparta={proposalToBeReviewedStageProps.isSparta}
                estimateLink={proposalToBeReviewedStageProps.estimateLink}
                reviewProposalLink={
                  proposalToBeReviewedStageProps.reviewProposalLink
                }
                theme={theme}
              />
            </>
          )}

        {isAtSettlement && (
          <>
            <SettlementStage
              firstName={settlementStageProps.firstName}
              vehicleDescription={settlementStageProps.vehicleDescription}
              theme={theme}
              settlementLink={settlementStageProps.settlementLink}
              proposalLink={settlementStageProps.proposalLink}
            />
          </>
        )}

        <ContentSection {...contentSectionData} />
      </E.HomeContainer>
    </Layout>
  )
}

function mapStateToProps(
  state: {
    authentication: { isAuthenticated: boolean; opportunityId: string }
    consultant: { firstName: string }
    user: { firstName: string; isGov: boolean }
    proposal: { proposal: { quoteId: string } }
    individualEstimate: { selectedEstimateId: string }
    applicationRoles: any
    auth: { accessToken: string }
    nextSteps: INextStepProps
  },
  ownProps: any
) {
  const { isAuthenticated, opportunityId } = state.authentication
  const { firstName: consultantFirstName } = state.consultant
  const { firstName: userFirstName } = state.user
  const proposalEstimateId =
    state.proposal && state.proposal.proposal && state.proposal.proposal.quoteId
      ? state.proposal.proposal.quoteId
      : null
  const selectedEstimateId =
    state.individualEstimate && state.individualEstimate.selectedEstimateId
  const applicationRole = state.applicationRoles
  const accessToken = state.auth.accessToken
  const nextSteps = state.nextSteps
  const isGov = globals.isBrandRS && state.user.isGov
  return {
    isAuthenticated,
    opportunityId,
    consultantFirstName,
    userFirstName,
    proposalEstimateId,
    selectedEstimateId,
    applicationRole,
    accessToken,
    nextSteps,
    isGov: isGov,
  }
}
export default connect(mapStateToProps)(withLocation(Home))
